import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataUtilService } from 'src/app/_services/data-util.service';
import { environment } from '../../environments/environment';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthHeader } from '../_models/headers';
import { ResultData } from '../_models/ResultData';
import { AuthService } from './auth.service';
import { HeaderService } from './header.service';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
aHeader = undefined
constructor(
    private dataUtilService: DataUtilService,
    private http: HttpClient,private tss:AuthService,
    private headerService:HeaderService
) {
  this.aHeader = new AuthHeader(tss)
}

imageAnswerConceptMediaFile(questionId:number, mediaFileName: string) {
  return this.http.get<any>(`${environment.apiUrl}/question/apigetanswerconceptfigure/${questionId}?mediaFileName=${mediaFileName}`,this.aHeader.bearerJsonHeaders).pipe(map(
    value=>{
      if(this.dataUtilService.isGoodResponse(value)){
        return this.dataUtilService.myData(value)
      }else{
        return {}
      }
    }
  ))
}




questionImage(questionId:number, partName: string) {
  return this.http.get<any>(`${environment.apiUrl}/question/apigetfigure/${questionId}?partName=${partName}`,this.aHeader.bearerJsonHeaders).pipe(map(
    value=>{
      if(this.dataUtilService.isGoodResponse(value)){
        return this.dataUtilService.myData(value)
      }else{
        return {}
      }
    }
  ))
}
questionObservableImage(questionId:number, mediaFileName: string):Observable<ResultData> {
  const hh = this.headerService.bearerJsonHeaders()
  return this.http.get<ResultData>(`${environment.apiUrl}/question/apigetfigure/${questionId}?mediaFileName=${mediaFileName}`,{headers:hh})
}
testImage() {
  return this.http.get<any>(`${environment.apiUrl}/tool/testimage`,this.aHeader.bearerJsonHeaders).pipe(map(
    value=>{
      if(this.dataUtilService.isGoodResponse(value)){
        return this.dataUtilService.myData(value)
      }else{
        return {}
      }
    }
  ))
}
questionOptionImage(questionId:number, partName: string) {
  return this.http.get<any>(`${environment.apiUrl}/question/getpromptoptionfigure/${questionId}?partName=${partName}`,this.aHeader.bearerJsonHeaders).pipe(map(
    value=>{
      if(this.dataUtilService.isGoodResponse(value)){
        return this.dataUtilService.myData(value)
      }else{
        return {}
      }
    }
  ))
}
giftInfo(server_student_id:number) {
  return this.http.get<any>(`${environment.apiUrl}/gifting/apigetfigure/${server_student_id}`,this.aHeader.bearerJsonHeaders)
}
redeemGift(server_student_id:number) {
  return this.http.get<any>(`${environment.apiUrl}/gifting/redeem/${server_student_id}`).pipe(map(
    value=>{
      if(this.dataUtilService.isGoodResponse(value)){
        return this.dataUtilService.myData(value)
      }else{
        return {}
      }
    }
  ))
}

showGiftImage(name:string) {
  return this.http.get<any>(`${environment.apiUrl}/giftDetail/getGift?name=${name}`,this.aHeader.bearerJsonHeaders).pipe(map(
    value=>{
      if(this.dataUtilService.isGoodResponse(value)){
        return this.dataUtilService.myData(value)
      }else{
        return {}
      }
    }
  ))
}



replaceAll(str:string, find:string, replace) {
  return str.replace(new RegExp(find,'g'), replace);
  }
}
